import React, { useEffect, useState, useReducer } from "react";
import ChartCard from "../../UI/Statistic/ChartCard";
import MostListCard from "../../UI/Statistic/MostListCardKaraoke";
import DateSelectDropdown from "../../UI/Statistic/DateSelectDropdown";
import CreationSelectDropdown from "../../UI/Statistic/CreationSelectDropdown";
import ArtistSelectDropdown from "../../UI/Statistic/ArtistSelectDropdown";
import axios from "axios";
import IncomeCard from "../../UI/Statistic/IncomeCard";
import ListenCard from "../../UI/Statistic/ListenCard";
import NotificationPopup from "../../UI/Login/NotificationPopup";

import { subMonths, setMonth, getMonth } from "date-fns";
import { distributionUrl, karaokeUrl } from "../../Config/url";
import { useAxiosKaraokeConfigGlobal } from "../../Config/axios";

const KaraokeStatistic = ({ oneRingRulesAll }) => {
  const axiosConfig = useAxiosKaraokeConfigGlobal();

  const addDays = (date, days) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
  };
  const dateMinusOne = addDays(new Date(), -1);

  const targetMonth = (getMonth(dateMinusOne) - 6 + 12) % 12;
  const resultDate = setMonth(subMonths(dateMinusOne, 6), targetMonth);

  const [mostCardsLoaded, setMostCardsLoaded] = useState(false);
  const [incomeLoaded, setIncomeLoaded] = useState(false);
  const [listensLoaded, setListensLoaded] = useState(false);
  const [mostLoaded, setMostLoaded] = useState(false);

  useEffect(() => {
    document.title = "MMusic - Статистик";
  }, []);

  const [dateFilter, setDateFilter] = useState(
    "filter[date][starts]=" +
      resultDate.getFullYear() +
      "-" +
      (resultDate.getMonth() + 1) +
      "-" +
      resultDate.getDate() +
      "&filter[date][ends]=" +
      dateMinusOne.getFullYear() +
      "-" +
      (dateMinusOne.getMonth() + 1) +
      "-" +
      dateMinusOne.getDate()
  );
  const [artistFilter, setArtistFilter] = useState("");
  const [albumFilter, setAlbumFilter] = useState("");
  const [songFilter, setSongFilter] = useState("");
  const [newRequest, setNewRequest] = useState(false);
  const [_, forceUpdate] = useReducer((x) => x + 1, 0);
  const [incomeData, setIncomeData] = useState("");
  const [sangData, setSangData] = useState([]);
  const [artistChanged, setArtistChanged] = useState(false);
  // ene 2 done zuv date ugch bga

  const [creationSortClicked, setCreationSortClicked] = useState(false);

  const [chartNumber, setChartNumber] = useState([]);
  const [chartDate, setChartDate] = useState([]);

  const [artistData, setArtistData] = useState([]);
  const [songData, setSongData] = useState([]);
  const [selectedAlbums, setSelectedAlbums] = useState([]);
  const [selectedSongs, setSelectedSongs] = useState([]);

  const [top5, setTop5] = useState([]);

  const [artistSearch, setArtistSearch] = useState("");
  const [creationQuery, setCreationQuery] = useState("");

  const [CKPopup, setCKPopup] = useState(false);
  const [CKPopupType, setCKPopupType] = useState("");
  const [CKPopupMessage, setCKPopupMessage] = useState("");
  useEffect(() => {
    setMostCardsLoaded(false);
    setIncomeLoaded(false);
    setListensLoaded(false);
    setMostLoaded(false);
  }, [newRequest]);

  useEffect(() => {
    const fetchArtists = async () => {
      try {
        const searchParam = artistSearch
          ? `filter[search]=${artistSearch}`
          : "";
        const url = `${distributionUrl}panel-api/oauth/karaoke/artists?${searchParam}`;

        const res = await axios.get(url, axiosConfig);
        setArtistData(res.data.data);
      } catch (err) {
        if (err.response?.status === 401) {
          oneRingRulesAll("logout");
        } else {
          console.error("Failed to fetch artists:", err);
        }
      }
    };

    fetchArtists();
  }, [artistSearch]);

  // Carickao: artist avdag api
  useEffect(() => {
    axios
      .get(
        distributionUrl +
          "panel-api/oauth/karaoke/songs?" +
          artistFilter +
          (creationQuery.length === 0
            ? ""
            : (artistFilter ? "&query=" : "query=") + creationQuery),
        axiosConfig
      )
      .then((res) => {
        setSongData(res.data.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          oneRingRulesAll("logout");
        }
      });
  }, [artistFilter, creationQuery]);

  // Carickao: duu avdag API
  useEffect(() => {
    axios
      .get(
        karaokeUrl +
          "panel-api/oauth/statistic:sangs?" +
          dateFilter +
          "&" +
          artistFilter +
          "&" +
          songFilter,
        axiosConfig
      )
      .then((res) => {
        chartNumber.length = 0;
        chartDate.length = 0;
        setGraphData(res.data);
        forceUpdate();
      })
      .catch((err) => {
        if (err.response.status === 401) {
          oneRingRulesAll("logout");
        }
      });
  }, [newRequest]);

  // Carickao: graphic iin data avdag api

  useEffect(() => {
    const fetchTopSongs = async () => {
      try {
        const res = await axios.get(
          `${karaokeUrl}panel-api/oauth/statistic:top?${dateFilter}&${artistFilter}&${songFilter}`,
          axiosConfig
        );

        // Шалгах хэсэг: res.data.data нь массив эсэхийг шалгах
        let originalList = res.data.data;

        // Хэрэв originalList нь массив биш бол, object-ийг массив болгон хөрвүүлнэ
        if (!Array.isArray(originalList)) {
          originalList = Object.values(originalList);
          console.error(
            "originalList is not an array, converting to array:",
            originalList
          );
        }

        const ids = originalList.map((song) => song.song_id).join(",");

        const response = await axios.get(
          `${distributionUrl}panel-api/oauth/songs/ids?ids=${ids}`,
          axiosConfig
        );

        // songMap үүсгэж, song-ийг song.id-р нь хайж тохируулах
        const songMap = {};
        response.data.data.forEach((song) => {
          songMap[song.id] = song;
        });

        // Enrich originalList with song data from the second API request
        const enrichedList = originalList.map((item) => ({
          ...item,
          song: songMap[Number(item.song_id)] || null,
        }));

        setTop5(enrichedList);
        setMostLoaded(true);
      } catch (err) {
        // Unauthorized access check
        if (err.response?.status === 401) {
          oneRingRulesAll("logout");
        } else {
          console.error("Error fetching top songs:", err);
        }
      }
    };

    fetchTopSongs();
  }, [newRequest]);

  const setGraphData = (data) => {
    let rangeText;
    // eslint-disable-next-line default-case
    switch (data?.range) {
      case "day":
        rangeText = "өдөр";
        break;
      case "month":
        rangeText = "сар";
        break;
      case "year":
        rangeText = "он";
        break;
    }
    data.data.map((a) => {
      // chartNumber.push(parseFloat(a.counts.replace(/,/g, "")));
      chartNumber.push(parseFloat(a.total));
      chartDate.push([a.processed, rangeText]);
    });
  };
  // TODO: artist soligdvol uran buteeleer haihiig boliulah

  useEffect(() => {
    axios
      .get(
        karaokeUrl +
          "panel-api/oauth/statistic:wallet?load=income&" +
          dateFilter +
          "&" +
          artistFilter +
          "&" +
          songFilter,
        axiosConfig
      )
      .then((res) => {
        setIncomeData(res.data.data);
        setIncomeLoaded(true);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          oneRingRulesAll("logout");
        }
      });
    axios

      .get(
        karaokeUrl +
          "panel-api/oauth/statistic:content?" +
          dateFilter +
          "&" +
          artistFilter +
          "&" +
          songFilter,
        axiosConfig
      )
      .then((res) => {
        setSangData(res.data.data);
        setListensLoaded(true);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          oneRingRulesAll("logout");
        }
      });
  }, [newRequest]);

  return (
    <div className="px-4 py-4 md:px-10 md:py-8">
      <h5 className="text-mmusic font-semibold text-xl">Миний самбар</h5>
      <div className="flex flex-col md:flex-row flex-wrap gap-4 xl:gap-8 pt-4 md:pt-6 relative">
        <div className="flex flex-col">
          <span className="font-bold pb-2 text-xs leading-4">Огноо</span>
          <DateSelectDropdown
            dateFilter={dateFilter}
            setDateFilter={setDateFilter}
            width="220"
            newRequest={newRequest}
            setNewRequest={setNewRequest}
            setCKPopup={setCKPopup}
            setCKPopupType={setCKPopupType}
            setCKPopupMessage={setCKPopupMessage}
            minDate={new Date(2024, 2, 1)}
          />
        </div>

        {/*Carickao: label baival garch ireed label bish bol garch irehgui bolgono */}
        <div className="flex flex-col">
          <span className="font-bold pb-2 text-xs leading-4">Артист</span>
          <ArtistSelectDropdown
            datas={artistData}
            setArtistFilter={setArtistFilter}
            setArtistSearch={setArtistSearch}
            setArtistChanged={setArtistChanged}
            width="200"
            newRequest={newRequest}
            setNewRequest={setNewRequest}
            setAlbumFilter={setAlbumFilter}
            setSongFilter={setSongFilter}
            selectedAlbums={selectedAlbums}
            setSelectedAlbums={setSelectedAlbums}
            selectedSongs={selectedSongs}
            setSelectedSongs={setSelectedSongs}
          />
        </div>
        <div className="flex flex-col">
          <span className="font-bold pb-2 text-xs leading-4">
            Уран бүтээлээр хайх
          </span>
          {/* <SelectDropdown datas={creationDropdownData} onChange={setCreation} width="200" /> */}
          <CreationSelectDropdown
            oneRingRulesAll={oneRingRulesAll}
            albumData={songData}
            setCreationQuery={setCreationQuery}
            creationQuery={creationQuery}
            setAlbumFilter={setAlbumFilter}
            setSongFilter={setSongFilter}
            newRequest={newRequest}
            setNewRequest={setNewRequest}
            setCreationSortClicked={setCreationSortClicked}
            creationSortClicked={creationSortClicked}
            artistChanged={artistChanged}
            setArtistChanged={setArtistChanged}
            selectedAlbums={selectedAlbums}
            setSelectedAlbums={setSelectedAlbums}
            selectedSongs={selectedSongs}
            setSelectedSongs={setSelectedSongs}
            width="200"
          />
        </div>
      </div>
      <div className="flex flex-col w-full pt-6 gap-6">
        <div className="flex flex-col md:flex-row w-full gap-6">
          <IncomeCard datas={incomeData} loaded={incomeLoaded} />
          <ListenCard type="karaoke" datas={sangData} loaded={listensLoaded} />
          {/* Carickao: enenii data fucked up */}
        </div>
        <div className="w-full h-72 2xl:h-96">
          <ChartCard
            type="karaoke"
            numbers={chartNumber}
            date={chartDate}
            color="0061FF"
            bgColor="0061FF"
            pointColor="0061FF"
            title="Дуулалтын тоо"
            karaokeColor="336CFB"
            karaokeBgColor="0061FF"
            karaokePointColor="93C5FD"
          />
        </div>
      </div>

      <div>
        {/* Delgetsnii hemjeenees bolood shahagdaad haragdahgui baisan tul ene deer responsive bichchihlee shuu */}
        <MostListCard
          datas={top5}
          wrapperClass="flex w-full mt-6 "
          responsiveClass="gap-3"
          loaded={mostLoaded}
        />
      </div>
      <div className="absolute right-4 md:right-5 top-5">
        <NotificationPopup
          type={CKPopupType}
          popupMessage={CKPopupMessage}
          popup={CKPopup}
          setPopup={setCKPopup}
          animDirectionTop={true}
        />
      </div>
    </div>
  );
};

export default KaraokeStatistic;
